// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoSearchDialog from "./../../factories/bao-search-dialog";
import ChildTabViewModel from "./../../factories/child-tab-view-model";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import TabPage from "./../../factories/tab-page";
import BaoDialogViewModel from "./../../factories/bao-dialog";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/sorting";
function UserConfigurationItemTabModel(tabPage, parent) {
    var self = this;
    self.TabPage = tabPage;
    self.Bao = Bao;
    self.User = parent;
    self.CompleteCheck = function () {
        return true;
    };
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.RefreshGrid();
    });
    self.PageSize = ko.observable(10);
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Sorting.subscribe(function () {
        self.RefreshGrid();
    });
    self.UserConfigurationItemCollection = ko.observableArray([]);
    var _deleteMessage = Bao.Session.GetMessage("msgDeleteUserConfigurationItem");
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "AddConfigurationItemToUser":
                self.ShowSearch();
                break;
            case "RemoveConfigurationItemFromUser":
                if (self.SelectedUserConfigurationItemRow() != null) {
                    var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessage, "yesno");
                    yesNoDialog.DialogResult.subscribe(function (result) {
                        if (result === true) {
                            self.DeleteUserConfigurationItem(self.SelectedUserConfigurationItemRow().UserConfigurationItemId);
                        }
                    });
                }
                break;
        }
    };
    self.ShowSearch = function () {
        var baoSearchDialog = new BaoSearchDialog();
        var config = {
            MultiSelect: true,
            ObjectId: ko.observable(),
            ObjectValue: "Name1",
            SearchType: "ConfigurationItems",
            AutoSearch: false,
            ApplyItemCallback: function (searchViewModel) {
                var configurationItemIds = [];
                ko.utils.arrayForEach(searchViewModel.Selection(), function (item: any) {
                    configurationItemIds.push(item.ConfigurationItemId);
                });
                self.TabPage.IsLoading(true);
                Bao.post("UadmCustom/UserTab/AddUserConfigurationItems", JSON.stringify({
                    sessionTabId: self.User.TabPage.SessionTabId,
                    userId: self.User.UserId(),
                    configurationItemIds: configurationItemIds
                }), function () {
                    self.RefreshGrid(true);
                    self.TabPage.IsLoading(false);
                });
            }
        };
        baoSearchDialog.InitSearcher(config);
    };
    self.RefreshGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("UadmCustom/UserTab/GetUserConfigurationItemCollection", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId,
            userId: self.User.UserId(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedUserConfigurationItemRow(null);
            self.TotalRows(0);
            self.UserConfigurationItemCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.UserConfigurationItemCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
            self.ToggleToolbarButtons();
        });
    };
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    self.DeleteUserConfigurationItem = function (userConfigurationItemId) {
        return Bao.post("UadmCustom/UserTab/DeleteUserConfigurationItem", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId,
            userId: self.User.UserId(),
            userConfigurationItemId: ko.unwrap(userConfigurationItemId)
        }), function () {
            self.User.TabPage.DirtyFlag(true);
            self.RefreshGrid();
        });
    };
    self.ToolbarButtons = ko.observableArray([]);
    self.ToolbarButtons.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.SelectedUserConfigurationItemRow = ko.observable({});
    self.SelectedUserConfigurationItemRow.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.ToggleToolbarButtons = function () {
        ko.utils.arrayForEach(self.ToolbarButtons(), function (button: any) {
            switch (button.ActionKey()) {
                case "RemoveConfigurationItemFromUser":
                    button.Enabled(!(self.SelectedUserConfigurationItemRow() == null));
                    break;
                case "AddConfigurationItemToUser":
                    button.Enabled(!self.User.IsNew());
                    break;
            }
        });
    };
    self.Refresh = function () {
        var def = $.Deferred();
        Bao.post("UadmCustom/UserTab/ResetUserConfigurationItem", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId
        }), function () {
            self.RefreshGrid().then(function () {
                def.resolve();
            });
        });
        return def.promise();
    };
    self.Save = function () {
        return Bao.post("UadmCustom/UserTab/SaveUserConfigurationItem", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId,
            userId: self.User.UserId(),
            saveTime: parent.SaveTime()
        }));
    };
    self.init = function () {
        return self.RefreshGrid();
    };
    self.loaded = function () {
        self.ToggleToolbarButtons();
    };
    self.Copy = function (userId, saveTime) {
        return Bao.post("UadmCustom/UserTab/CopyUserConfigurationItem", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId,
            userId: self.User.UserId(),
            newUserId: userId,
            saveTime: saveTime
        }));
    };
}
;
export default UserConfigurationItemTabModel;